import BackToTop from "./back-to-top";

export default BackToTop;